var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{attrs:{"title":_vm.$t('csr.section.banner.title'),"paragraphs":_vm.$t('csr.section.banner.paragraphs'),"title-class":_vm.titleClass}})}
var staticRenderFns = []

export { render, staticRenderFns }